var map = {
	"./1.png": 128,
	"./4.png": 62026,
	"./5.png": 76383,
	"./5000.png": 60028,
	"./5001.png": 44465,
	"./5003.png": 39206,
	"./56.png": 85008,
	"./97.png": 70682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24821;